// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__oSb4A","filters_close":"FiltersBlock_filters_close__4X7o4"};